module.exports = __webpack_public_path__ + "img/bg_4.d3297742.png";